import * as Constants from "../Data/Constants";

export class AppProgress {
    private static _activeLevel: number = 0;
    private static _activeBalloon: number = 0;
    private static _levelsCompleted: number = 0;
    private static _currentLevelCompleted: boolean = false;
    private static _checkpointReached: boolean = false;
    private static _onboardingComplete: boolean = false;

    public static get activeLevel(): number {
        return this._activeLevel;
    }

    public static set activeLevel(pValue: number) {
        this._activeLevel = pValue;
    }

    public static get activeBalloon(): number {
        return this._activeBalloon;
    }

    public static set activeBalloon(pValue: number) {
        this._activeBalloon = pValue;
    }

    public static get levelsCompleted(): number {
        return this._levelsCompleted;
    }

    public static set levelsCompleted(pValue: number) {
        this._levelsCompleted = pValue;
    }

    public static get currentLevelCompleted(): boolean {
        return this._currentLevelCompleted;
    }

    public static set currentLevelCompleted(pValue: boolean) {
        this._currentLevelCompleted = pValue;
    }

    public static get checkpointReached(): boolean {
        return this._checkpointReached;
    }

    public static set checkpointReached(pValue: boolean) {
        this._checkpointReached = pValue;
    }

    public static get onboardingComplete(): boolean {
        return Constants.DEBUG_SKIP_ONBOARDING ? true : this._onboardingComplete;
    }

    public static set onboardingComplete(pValue: boolean) {
        this._onboardingComplete = pValue;
    }
}
